import { RequestCustomerResetPasswordResponse, syliusFetch, UpdateCustomerPasswordResponse } from '../../../entities/@api/Sylius';
import { NewPasswordFormBase } from '../../../entities/@forms/ChangePasswordForm/ChangePasswordForm';
import { RequestResetPasswordFormData } from '../../../entities/@forms/RequestResetPasswordForm/RequestResetPasswordForm';
import { isFetchResultSuccessful } from '../../../entities/FetchResult/FetchResult';
import trans from '../../../helpers/trans';
import { ReduxFetchAction } from '../../defaults';
import { addNegativeToast, addPositiveToast } from '../../toast/toastActions';
import {
    setError,
    setHasChangedSuccessfully,
    setHasRequestedSuccessfully,
    setIsLoading,
} from './resetPasswordSlice';

export const requestResetPassword: ReduxFetchAction<RequestResetPasswordFormData> = formData => async dispatch => {
    dispatch(setIsLoading(true));
    dispatch(setError(''));
    dispatch(setHasRequestedSuccessfully(false));

    try {
        const requestBody = {
            email: formData.username,
        };

        const resetPasswordResponse = await syliusFetch<RequestCustomerResetPasswordResponse>('/shop/customers/reset-password', {
            method: 'POST',
            body: JSON.stringify(requestBody),
        });

        if (!isFetchResultSuccessful(resetPasswordResponse)) {
            dispatch(setError(resetPasswordResponse.error));
            return;
        }

        dispatch(addPositiveToast({
            title: trans('redux.resetPassword.requested.successMessageTitle'),
            description: trans('redux.resetPassword.requested.successMessageDescription'),
        }));

        dispatch(setHasRequestedSuccessfully(true));
    } catch (error) {
        console.error('[requestResetPassword]', error);
    } finally {
        dispatch(setIsLoading(false));
    }
};

interface ResetPasswordParams {
    token: string;
    formData: NewPasswordFormBase;
}

export const resetPassword: ReduxFetchAction<ResetPasswordParams> = data => async dispatch => {
    dispatch(setIsLoading(true));
    dispatch(setError(''));
    dispatch(setHasChangedSuccessfully(false));

    try {
        const resetPasswordResponse = await syliusFetch<UpdateCustomerPasswordResponse>(`/shop/customers/reset-password/${data.token}`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/merge-patch+json' },
            body: JSON.stringify(data.formData),
        });

        if (!isFetchResultSuccessful(resetPasswordResponse)) {
            dispatch(setError(resetPasswordResponse.error));

            dispatch(addNegativeToast({
                title: trans('redux.resetPassword.reset.messageTitle'),
                description: trans('redux.resetPassword.reset.failedMessageDescription'),
            }));

            return;
        }

        dispatch(setHasChangedSuccessfully(true));

        dispatch(addPositiveToast({
            title: trans('redux.resetPassword.reset.messageTitle'),
            description: trans('redux.resetPassword.reset.successMessageDescription'),
        }));
    } catch (error) {
        console.error('[resetPassword]', error);
    } finally {
        dispatch(setIsLoading(false));
    }
};
